module.exports = __webpack_public_path__ + "static/media/3DPPA26.93928f5c.jpg";